import { EntryList } from '../entry-list';
import { ENTRY_STATUS_LABELS, EntryInfo, EntryStatus } from '../utils';
import css from './entry-group.module.scss';

type EntryGroupProps = {
    status: EntryStatus;
    entries: EntryInfo[];
    open: boolean;
    onToggle: () => void;
};

export function EntryGroup({ status, entries, open, onToggle }: EntryGroupProps) {
    if (entries.length === 0) return null;

    return (
        <div className={css.groupBox} data-status={status} data-open={open}>
            <button type="button" className={css.groupHeader} onClick={onToggle} aria-expanded={open}>
                <span className={css.statusDot} />
                <span className={css.groupLabel}>{ENTRY_STATUS_LABELS[status]}</span>
                <span className={css.groupCount}>{entries.length}</span>
                <span className={css.groupChevron} />
            </button>
            {open && (
                <div className={css.scrollArea}>
                    <EntryList entries={entries} />
                </div>
            )}
        </div>
    );
}
